import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import MainLayout from "../../../component/atoms/layout/mainLayout";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import TextFormEditor from "./../../../component/atoms/input/textFormEditor";
import BasicBtn from "./../../../component/atoms/button/basicBtn";

import Header from "../../../component/organisms/header";
import Sidebar from "../../../component/organisms/sidebar";

import { route } from "../../../router/route";
import scrollToTop from "../../../util/scrollToTop";
import BoardApi from "../../../api/board.api";

const WritingCrewGuideEdit = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getGuideInfo();
  }, []);

  // ---------- 라이팅크루지도 상세 정보 ---------- //
  const [guideInfo, setGuideInfo] = useState();
  const [content, setContent] = useState();

  const getGuideInfo = async () => {
    try {
      const data = {
        page: 1,
        size: 1,
        boardPostType: "CREW_GUIDE",
      };

      const response = (await BoardApi.getListBoard(data)).data.data.content;

      if (response && response.length > 0) {
        const detailResponse = (await BoardApi.getByIdBoard(response[0].id))
          .data.data.content;

        setGuideInfo(detailResponse);
        setContent(detailResponse.content);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // ---------- 라이팅크루지도 수정 ---------- //
  const updateGuide = async () => {
    try {
      const response = await BoardApi.updateBoard(guideInfo.id, {
        title: "멤버십 가이드",
        content: content,
      });

      navigate(route.crew_guide, { replace: true });
      scrollToTop();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>멤버십 가이드</TableTitle>
          <TextFormEditor
            placeholder={"상세 내용을 입력해주세요"}
            value={content}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onChange={(e) => {
              setContent(e);
            }}
            editorHeight={600}
            style={{
              width: "100%",
            }}
          />
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            {/* <BasicBtn isBlue={true} onClick={() => {}}>
              미리보기
            </BasicBtn> */}
            <BasicBtn onClick={updateGuide}>업로드하기</BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>
    </>
  );
};

export default WritingCrewGuideEdit;
